<template>
  <v-row>
    <v-col cols="12">
      <v-fade-transition mode="out-in">
        <customer-loading
          v-if="loading.customerById == customerId"
        ></customer-loading>

        <v-card v-else tile flat color="transparent" key="card">
          <v-card-title class="px-0 pt-0">
            <v-row align="center">
              <v-col>
                <div class="headline">
                  <router-link
                    class="customer-name pb-1"
                    :to="{
                      name: 'customer',
                      params: { customer_id: customer.id }
                    }"
                  >
                    {{ customer.name }}
                  </router-link>
                  <span v-if="routeName" class="text-capitalize">
                    - {{ routeName.replace('_', ' ').replace('.', ' ') }}
                  </span>
                </div>
              </v-col>

              <v-col align="right">
                <v-layout class="d-block">
                  <v-btn
                    text
                    color="secondary"
                    class="ml-1"
                    :to="{
                      name: 'customer.settings',
                      params: { customer_id: customer.id }
                    }"
                    v-if="$can('customers.settings')"
                    >Settings</v-btn
                  >
                </v-layout>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="pa-0">
            <v-fade-transition mode="out-in">
              <router-view></router-view>
            </v-fade-transition>
          </v-card-text>
        </v-card>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CustomerLoading from '@/components/customers/CustomerLoading'

export default {
  name: 'Customer',
  components: {
    CustomerLoading
  },
  computed: {
    ...mapGetters('customers', ['customer', 'loading']),
    customerId() {
      return this.$route.params.customer_id
    },
    routeName() {
      return this.$route.name !== 'customer'
        ? this.$route.name.replace('customer.', '')
        : ''
    }
  },
  methods: {
    ...mapActions('customers', ['fetchCustomer'])
  },
  created() {
    this.fetchCustomer(this.customerId)
  }
}
</script>

<style lang="scss">
.customer-name {
  border-bottom: 1px solid;
}
</style>
